
/**
 * 
 * 
 */
export enum GridControlTypes {

    /**
     * 
     */
    Undefined = 0,

    /**
     * 
     */
    Text = 1,

    /**
     * 
     */
    Number = 2,

    /**
     * 
     */
    Date = 3,

    /**
     * 
     */
    Checkbox = 4,

    /**
     * 
     */
    List = 5,

    /**
     * 
     */
    SelectDialog = 6,

    /**
     * 
     */
    Image = 7,

    /**
     * 
     */
    TextBlock = 8,

    /**
     * 
     */
    HiddenText = 9,

    /**
     * 
     */
    HiddenDate = 10,

    /**
     * 
     */
    DateTime = 11,

    /**
     * 
     */
    Time = 12,

    /**
     * 
     */
    TextTextBlock = 13,

    /**
     * 
     */
    MaskedTextBox = 14,

    /**
     * 
     */
    ComboBox = 15,

    /**
     * 
     */
    HtmlEditor = 20,

    /**
     * 
     */
    FileUpload = 21,

    /**
     * 
     */
    ContextMenu = 23,

    /**
     * 
     */
    RtfEditor = 24,

    /**
     * 
     */
    DatabaseImage = 25,

    /**
     * 
     */
    ThreeStateCheckbox = 26,

    /**
     * 
     */
    ColorPicker = 27,

    /**
     * 
     */
    Custom = 28,

    /**
     * 
     */
    MultiSelect = 29,

    /**
     * 
     */
    AutoComplete = 30,

    /**
     * 
     */
    PeoplePicker = 31,

    /**
     * 
     */
    DateTimeNoTimeZone = 32,

    /**
     * 
     */
    Edit = 101,

    /**
     * 
     */
    Cancel = 102,

    /**
     * 
     */
    Add = 103,

    /**
     * 
     */
    Update = 104,

    /**
     * 
     */
    Delete = 105,

    /**
     * 
     */
    Command = 106,

    /**
     * 
     */
    Link = 107,

    /**
     * 
     */
    SelectButton = 108,

    /**
     * 
     */
    MultiPageUpdate = 109,

    /**
     * 
     */
    DatasetCommand = 110,
}
